
export default function clearAuth() {
  Object.keys(localStorage).filter((x) => {
    return  x === 'UserAuth' || x.match(/^CognitoIdentity/) || x.match(/^aws\.cognito/) || x.match(/^amplify-/)
  }).forEach((key) => {
    window.localStorage.removeItem(key)
  })
}
